<template>
    <el-dialog :visible.sync="dialogVisible" width="50%" :append-to-body="true" :show-close="false">
      <div class="tweetImageDiv" style="height:80vh" id="tweetImageDiv">
        <p class="title">特推图选择</p>
        <div v-show="!adddialogVisible">
          <div v-if="resourceStateList.length>0" class="typeList">
            <div>
              <div @click="onlySeeOneType(checkResourceStateList.length===resourceStateList.length?'':'all')"
              :class="checkResourceStateList.length===resourceStateList.length?'checkedLi':''">全部</div>
              <div v-for="(name,ind) in resourceStateList" :key="ind" :class="checkResourceStateList.indexOf(name)!=-1?'checkedLi':''"
                @click="onlySeeOneType(name)">{{stockTypeMap[name].typeNameSimple}}</div>
            </div>
            <div>
              <el-button @click="dialogVisible=false" size="mini">关闭</el-button>
              <el-button type="primary" @click="addTweetLink" size="mini">保存</el-button>
            </div>
          </div>
          <div>
            <div v-for="(item,index) in resourceList" :key="index" :id="item.resourceId">
              <div v-if="checkResourceStateList.indexOf(item.state)!=-1" class="resoueceList">
                <div class="name">{{item.resourceName}}</div>
                <div class="option" @click="edit(item)">{{item.allTweets&&item.allTweets.length>0?'选择':'添加'}}</div>
                <div class="image">
                  <div v-for="(item1,index1) in item.tweets" :key="index1">
                    <p>{{item1.word}}</p>
                    <div style="display:flex">
                      <el-checkbox-group v-model="item1.checkList" v-for="(item2,index2) in item1.picList" :key="index2" style="position: relative;"
                        @change="changeCheckList(item1,item.tweets,index1)">
                        <el-image style="width: 133px;height:83px;margin:0.1rem 0.1rem 0 0;"
                        :src="item2" :preview-src-list="item1.picList"></el-image>
                        <el-checkbox :label="item2" style="position: absolute;top: 0.2rem;left: 0.1rem;"></el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                </div>
                <i class="el-icon-top" style="font-size: 0.3rem;" @click="zhiding(item)"></i>
              </div>
            </div>
          </div>
        </div>
        <div v-show="adddialogVisible">
          <div class="chooseImagePage">
            <div :class="activeName=='first'?'chooseDiv':''" @click="activeName='first'">已有特推图</div>
            <div :class="activeName=='second'?'chooseDiv':''" @click="activeName='second'">上传新的特推图</div>
          </div>
          <div class="contentDiv">
            <div v-show="activeName=='first'">
              <p class="tipInfo">请点选您所需展示的特推图（被选中的将会在在手机和word版本的方案中显示）<span class="tipInfoSpan">可多选</span></p>
              <p class="resourceName">{{editObj.resourceName}}&nbsp;&nbsp;的特色描述及特推图</p>
              <p class="tipInfo1" v-show="editObj.allTweets&&editObj.allTweets.length==0">暂无图片，请点击右上方“上传新的特推图”添加。</p>
              <div v-show="editObj.allTweets&&editObj.allTweets.length>0">
                <div v-for="(item,index) in editObj.allTweets" :key="index">
                  <div style="display: flex;">
                    <div style="margin-right: 0.1rem;">
                      <div><i style="color: #DB4E1A;font-size: 0.3rem;" class="el-icon-circle-plus" @click="addOtherPic(item)"></i></div>
                      <div class="lineClass">
                        <div></div>
                        <div v-show="index!=(editObj.allTweets.length-1)"></div>
                      </div>
                    </div>
                    <div>
                      <div>
                        <div style="margin-left: 0.1rem;font-size:0.18rem">{{item.word}}</div>
                      </div>
                      <div style="display: flex;padding-bottom: 0.1rem;align-items: center;">
                        <div class="imageDiv" style="display: flex;width: 7.8rem;overflow-x: scroll;">
                          <el-checkbox-group v-model="item.checkList" v-for="(item2,index2) in item.picList" :key="index2" style="position: relative;"
                            @change="changePicList">
                            <el-image style="width: 133px;height:83px;margin:0.1rem 0.1rem 0 0;"  :key="index2"
                            :src="item2" :preview-src-list="item.picList"></el-image>
                            <el-checkbox :label="item2" style="position: absolute;top: 0.2rem;left: 0.1rem;"></el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <a class="tipInfoSpan" @click="addOtherPic(item)" style="margin-left: 0.1rem;">添加</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="activeName=='second'">
              <p class="resourceName">{{editObj.resourceName}}&nbsp;&nbsp;的特色描述及特推图</p>
              <el-input type="textarea" :rows="4" placeholder="请在此处 输入特色描述" v-model="word" maxlength="200"
                show-word-limit style="margin-bottom: 0.2rem;" :disabled="editWord&&editWord.status!=0"></el-input>
              <upload ref="upload" :picLimit="100" style="margin-bottom: 0.2rem;"></upload>
            </div>
            <div style="text-align: center;">
              <span class="tipInfoSpan" v-show="activeName=='first'&&(editObj.allTweets&&editObj.allTweets.length>0)" style="margin-right: 0.3rem;">已选{{editObj.checkNumber}}张</span>
              <el-button @click="goBack">返回</el-button>
              <el-button type="primary" v-show="(editObj.allTweets&&editObj.allTweets.length>0)||activeName=='second'" @click="addTweetImage" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
            </div>
          </div>

        </div>
      </div>
    </el-dialog>
</template>

<script>
import {stockTypeMap} from '@/assets/utils/commonData'
import PlanApi from '@/components/Api/PlanApi.js'
import Api from '@/components/Api/index.js'
import upload from '../children/upload.vue'
import TweetList from '../children/tweetList.vue'
export default {
  components: { upload, TweetList },
  data(){
    return{
      dialogVisible:false,
      resourceList:[],
      resourceStateList:[],
      checkResourceStateList:[],
      stockTypeMap,
      srcList:[],
      adddialogVisible:false,
      editObj:{},
      activeName:'first',
      word:'',
      fullscreenLoading:false,
      height:0,
      editWord:null,
    }
  },
  methods:{
    addOtherPic(item){
      this.word = item.word
      this.activeName = "second"
      this.editWord = item
    },
    zhiding(item){
      this.$set(item,'sort',this.resourceList[0].sort+1)
      this.resourceList = this.sortArr(this.resourceList)
    },
    sortArr(arr){
      return arr.sort(function (a, b) {
        let x = a.sort
        let y = b.sort
        return ((x < y) ? 1 : (x > y) ? -1 : 0)
      })
    },
    goBack(){
      this.adddialogVisible = false
      this.$nextTick(()=>{
        document.getElementById('tweetImageDiv').scrollTop = this.editObj.scrollTop
      })
    },
    changeCheckList(item,item1,index){
      item.picList = item.checkList
      if(item.checkList.length==0){
        item1.splice(index,1)
      }
    },
    addTweetImage(){
      if(this.activeName=='first'){
        var list = []
        this.editObj.allTweets.forEach(e=>{
          if(e.checkList.length>0){
            var obj = JSON.parse(JSON.stringify(e))
            this.$set(obj,'picList',e.checkList)
            list.push(obj)
          }
        })
        this.editObj.tweets=list
        this.adddialogVisible=false
      }else{
        if(this.$refs.upload.fileList.length>0){
          this.fullscreenLoading = true;
          this.editObj.word = this.word
          if(this.editWord){
            this.editObj.id = this.editWord.resourceTweetId
          }
          if(this.editObj.productType==3){
            const form = new FormData();
            this.$refs.upload.fileList.forEach(ee=>{
              form.append("files",ee.raw); 
            })
            form.append("word", this.editObj.word);
            form.append("planId", this.editObj.planId);
            form.append("budgetMainId", this.editObj.budgetMainId);
            form.append("resourceName", this.editObj.resourceName);
            form.append("budgetId", this.editObj.resourceId);
            new PlanApi('plan').addBudgetTweet(form).then((res1) => {
              if (res1.status === 200) {
                var uploadObj = this.editObj.allTweets.find(e=>e.word==this.editObj.word)
                if(uploadObj){
                  uploadObj.picList = [...uploadObj.picList,...res1.data]
                }else{
                  this.editObj.allTweets.push({
                    resourceTweetId:0,
                    word:this.word,
                    picList:res1.data,
                    checkList:[],
                  })
                }
                this.clearUpload()
              }
            }).catch(er=>{
              this.fullscreenLoading = false;
            });
          }else{
            new Api('resource').addResourceTweet(this.editObj).then((res) => {
              var postCount=0;
              if (res.status === 200) {
                if(this.editWord){
                  this.editWord=null
                }else{
                  var obj = {
                    resourceTweetId:res.data,
                    word:this.word,
                    picList:[],
                    checkList:[],
                  }
                  this.editObj.allTweets.push(obj)
                }
                this.$refs.upload.fileList.forEach(ee=>{
                  const form = new FormData();
                  form.append("file", ee.raw); // 第三个参数为文件名
                  form.append("parentId", res.data);
                  form.append("flodName", '');
                  form.append("ossPath", 'resourceTweet');
                  new Api('resource').uploadResourceSingle(form).then((res1) => {
                    if (res1.status === 200) {
                      var uploadObj = this.editObj.allTweets.find(e=>e.resourceTweetId==res.data)
                      uploadObj.picList.push(res1.data.url)
                      postCount++;
                      if(postCount==this.$refs.upload.fileList.length){
                        this.clearUpload();
                      }
                    }
                  }).catch(er=>{
                    this.fullscreenLoading = false;
                  });
                })
              }
            }).catch(er=>{
              this.fullscreenLoading = false;
            });
          }
        }else{
          this.$message.error(`请先选择上传的图片`);
        }
      }
    },
    clearUpload(){
      this.$set(this.$refs.upload,'fileList',[])
      this.$refs.upload.$refs.upload.clearFiles()
      this.fullscreenLoading = false;
      this.activeName='first'
      this.$message.success("上传成功");
      this.word= ''
    },
    addTweetLink(){
      new PlanApi('plan').tweetImageAdd(this.resourceList).then(res => {
        if (res.status == 200) {
          this.$message({type:"success",message:"保存成功"})
        }
      })
    },
    onlySeeOneType(type){// 根据接受的type显示列表项
      if(type===''){
        this.checkResourceStateList = []
      }else if(type=='all'){
        this.checkResourceStateList = []
        this.resourceStateList.forEach((item,index) => {
          this.checkResourceStateList.push(item)
        })
      }else if(this.checkResourceStateList.indexOf(type)!=-1){
        this.checkResourceStateList.splice(this.checkResourceStateList.indexOf(type),1)
      }else{
        this.checkResourceStateList.push(type);
      }
    },
    chuliData(res,e){
      var obj = res.data.find(eee=>eee.resourceId==e.resourceId)
      if(obj){
        this.$set(e,"allTweets",obj.allTweets)
        obj.tweets.forEach(e=>{
          this.$set(e,'checkList',e.picList)
        })
        this.$set(e,"tweets",obj.tweets)
        this.$set(e,"sort",obj.sort)
      }
    },
    beforOpen(budget){
      this.dialogVisible = true;
      this.resourceStateList=[]
      this.checkResourceStateList=[]
      this.resourceList=[]
      this.srcList=[]
      budget.planDayList.forEach(element => {
        if(element.budgetDetails){
          element.budgetDetails.forEach(e=>{
            if(e.resourceId!=0){
              if(this.resourceList.findIndex(ee=>e.resourceId==ee.resourceId)==-1){
                this.resourceList.push({
                  resourceId:e.resourceId,
                  resourceName:(e.resourceNameCn&&e.resourceNameCn!=''?e.resourceNameCn:e.resourceNameEn),
                  resourceNameEn:e.resourceNameEn,
                  planId:budget.planId,
                  budgetMainId:budget.id,
                  productType:(e.productType==1||e.productType==5)?1:2,
                  state:e.state,
                  allTweets:[],
                  tweets:[]
                })
              }
              if(this.resourceStateList.indexOf(e.state)==-1){
                this.resourceStateList.push(e.state)
                this.checkResourceStateList.push(e.state)
              }
            }else{
              if(this.resourceList.findIndex(ee=>e.resourceId==ee.resourceId)==-1){
                this.resourceList.push({
                  resourceId:e.id,
                  resourceName:e.resourceNameCn,
                  resourceNameEn:'',
                  planId:budget.planId,
                  budgetMainId:budget.id,
                  productType:3,
                  state:e.state,
                  allTweets:[],
                  tweets:[]
                })
              }
              if(this.resourceStateList.indexOf(e.state)==-1){
                this.resourceStateList.push(e.state)
                this.checkResourceStateList.push(e.state)
              }
            }
          })
        }
      });
      var resourceIds = this.resourceList.filter(r=>r.productType!=3).map(r=>r.resourceId)
      var budgetIds = this.resourceList.filter(r=>r.productType==3).map(r=>r.resourceId)
      if(resourceIds.length>0){
        new PlanApi('plan').tweetImage({resourceIds:resourceIds,budgetMainId:budget.id}).then(res => {
          if (res.status == 200) {
            this.resourceList.forEach(e=>{
              if(e.productType!=3){
                this.chuliData(res,e)
              }
            })
            this.resourceList = this.sortArr(this.resourceList)
          }else{
            this.$message({type:"error",message:"数据加载失败"})
          }
        })
      }
      if(budgetIds.length>0){
        new PlanApi('plan').listText({resourceIds:budgetIds,budgetMainId:budget.id}).then(res => {
          if (res.status == 200) {
            this.resourceList.forEach(e=>{
              if(e.productType==3){
                this.chuliData(res,e)
              }
            })
            this.resourceList = this.sortArr(this.resourceList)
          }else{
            this.$message({type:"error",message:"数据加载失败"})
          }
        })
      }
    },
    edit(item){
      this.adddialogVisible = true
      this.editObj = item
      var checkNumber = 0;
      this.editObj.allTweets.forEach(e=>{
        var obj = this.editObj.tweets.find(ee=>ee.resourceTweetId==e.resourceTweetId)
        var checkList=[]
        if(obj){
          checkList = obj.picList
        }
        checkNumber+=checkList.length;
        this.$set(e,'checkList',checkList)
      })

      this.$set(this.editObj,'scrollTop', document.getElementById('tweetImageDiv').scrollTop)
      this.$set(this.editObj,'checkNumber',checkNumber)
    },
    changePicList(){
      var checkNumber = 0;
      this.editObj.allTweets.forEach(e=>{
        checkNumber+=e.checkList.length;
      })
      this.$set(this.editObj,'checkNumber',checkNumber)
    }
  },
  mounted(){
    this.height = document.body.clientHeight-229
  }
}
</script>

<style lang="scss" scoped>
.tweetImageDiv{
  padding-right: 0.2rem;
  overflow-y: scroll;
  overflow-x:hidden;
  /deep/ .el-checkbox__label{
    display: none;
  }
  /deep/ .el-checkbox__inner{
    width: 0.24rem;
    height: 0.24rem;
    background-color: white;
  }
  /deep/ .el-checkbox__inner::after{
    border-right: 0.02rem solid red;
    border-bottom: 0.02rem solid red;
    width: 0.07rem;
    height: 0.14rem;
    left: 0.07rem;
  }
}
.contentDiv{
  background-color: #F7F7F7;
  width: 9rem;
  margin: 0 auto;
  padding: 0.2rem;
  .tipInfoSpan{
    font-size: 0.12rem;
    color: #618C04;
  }
  .tipInfo{
    font-size: 0.16rem;
    color: #101010;
    margin-bottom: 0.2rem;
  }
  .tipInfo1{
    font-size: 0.16rem;
    color: #618C04;
  }
  .resourceName{
    font-size: 0.18rem;
    color: #DB4E1A;
    margin-bottom: 0.2rem;
  }
  .lineClass{
    height: 80%;
    width: 50%;
    margin-left: 0.14rem;
    >div:first-child{
      height: 50%;
      border-bottom: 1px solid #DB4E1A;
      border-left: 1px solid #DB4E1A;
    }
    >div:last-child{
      border-left: 1px solid #DB4E1A;
      height: 50%;
    }
  }
}
.tweetImageDiv{
  color: #000000;
}
.chooseImagePage{
  display: flex;
  font-size: 0.18rem;
  width: 9rem;
  text-align: center;
  margin: 0.1rem auto 0 auto;
  color: #101010;
  .chooseDiv{
    color: #DB4E1A;
    font-size: 0.23rem;
    border-bottom: 15px solid #DB4E1A;
  }
  >div{
    width: 50%;
    padding: 0.2rem 0;
    border-bottom: 15px solid #bbbbbb;
  }
}
.typeList{
  display: flex;
  align-items: center;
  margin-top: 0.1rem;
  border-top: 1px solid rgba(187, 187, 187, 1);
  border-bottom:  1px dashed rgba(187, 187, 187, 1);
  padding: 0.15rem 0rem;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background: white;
  z-index: 2;
  .checkedLi{
    background: #db4e1a;
    color: #fff;
    border-color: #db4e1a;
  }
  >div{
    display: flex;
    align-items: center;
    >div:first-child{
    width: 0.35rem;
    border-radius: 0;
    }
    >div{
      width: 0.28rem;
      height: 0.28rem;
      border-radius: 50%;
      border: 1px solid #dcdcdc;
      line-height: 0.25rem;
      text-align: center;
      cursor: pointer;
      margin-right: 0.1rem;
    }
  }
}
.resoueceList{
  border-bottom: 1px dashed #bbbbbb;
  padding: 0.1rem 0;
  display: flex;
  align-items: center;
  .name{
    width: 2rem;
    margin-right: 0.2rem;
  }
  .option{
    color: #618C04;
    width: 0.39rem;
  }
  .image{
    width: 7rem;
    margin-left: 0.2rem;
    overflow-x: auto;
  }
  .image::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  .image::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: rgb(205,205,205);
  }
  .image::-webkit-scrollbar-track {
    background-color: white;
    border-bottom: 2px solid #cacaca;
  }
}
.title{
  font-size: 0.28rem;
  color: #101010;
  text-align: center;
}
.imageDiv{
  padding-bottom: 0.05rem;
}
.imageDiv::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.imageDiv::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: rgb(205,205,205);
}
.imageDiv::-webkit-scrollbar-track {
  background-color: white;
  border-bottom: 2px solid #cacaca;
}
</style>
